/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicCloudNativeThreatSync extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicCloudNativeThreatSync");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicCloudNativeThreatSync.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicCloudNativeThreatSync>): BackgroundJobPayloadForPeriodicCloudNativeThreatSync {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicCloudNativeThreatSync(), model);
        BackgroundJobPayloadForPeriodicCloudNativeThreatSync.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicCloudNativeThreatSync>): BackgroundJobPayloadForPeriodicCloudNativeThreatSync {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicCloudNativeThreatSync.newInstance(<BackgroundJobPayloadForPeriodicCloudNativeThreatSync> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicCloudNativeThreatSync) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicCloudNativeThreatSync.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicCloudNativeThreatSync): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicCloudNativeThreatSync.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
